import { createSelector } from 'reselect';

import { State } from '../../Types';

const spacesState = ({ spaces }: State) => spaces;

// Spaces
const spacesSlice = createSelector(spacesState, ({ spaces }) => spaces);

export const spaces = createSelector(spacesSlice, (spaces) => spaces);

export const space = (spaceId: number | string) => createSelector(spaces, (spaces) => spaces[spaceId] || {});

export const spacesAreLoaded = (spaceIds: number[]) =>
    createSelector(spaces, (spaces) => {
        const spacesStateIds = Object.keys(spaces);

        return !!!spacesStateIds.length ? false : spaceIds.every((id) => spacesStateIds.includes(`${id}`));
    });

// Space Occupants
const spaceOccupantsSlice = createSelector(spacesState, ({ spaceOccupants }) => spaceOccupants);

export const spaceOccupants = (spaceId: number | string) =>
    createSelector(spaceOccupantsSlice, (spaceOccupants) => spaceOccupants[spaceId] || []);

export const occupantsLoadedForSpace = (spaceId: number | string) =>
    createSelector(spaceOccupantsSlice, (spaceOccupants) => spaceOccupants.hasOwnProperty(spaceId));
